(function freeGiftPopupReleaseScrollLock() {
  let guardInterval = null;
  let guardObserver = null;
  let guardStop = null;

  const release = () => {
    const html = document.documentElement;
    const body = document.body;
    html.removeAttribute('scroll-lock');
    for (const el of [html, body]) {
      if (el.style.overflow === 'hidden') el.style.overflow = '';
      if (el.style.overflowY === 'hidden') el.style.overflowY = '';
    }
    if (body.style.paddingRight) body.style.paddingRight = '';
    if (body.style.position === 'fixed') body.style.position = '';
    if (body.style.top) body.style.top = '';

    const sl = window.scrollLock;
    if (sl?.clearQueueScrollLocks) sl.clearQueueScrollLocks();
    if (sl?.enablePageScroll) for (let i = 0; i < 10; i++) sl.enablePageScroll();
  };

  const startGuard = () => {
    clearInterval(guardInterval);
    clearTimeout(guardStop);
    guardObserver?.disconnect();

    release();
    guardInterval = setInterval(release, 50);
    guardObserver = new MutationObserver(release);
    guardObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scroll-lock', 'style'],
    });
    guardObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });

    guardStop = setTimeout(() => {
      clearInterval(guardInterval);
      guardObserver.disconnect();
      release();
    }, 3000);
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.wpopup_x_button, .wpopup_nothanks_btn')) return startGuard();
      const popup = target.closest('.wpopup_main');
      if (popup && !popup.querySelector('.wpopup_container')?.contains(target)) startGuard();
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      if (event.target instanceof Element && event.target.classList.contains('wpopup_main')) {
        startGuard();
      }
    },
    true
  );

  const watchPopup = (popup) => {
    if (popup.__sl) return;
    popup.__sl = true;
    let wasOpen = popup.hasAttribute('open');
    new MutationObserver(() => {
      const isOpen = popup.hasAttribute('open');
      if (wasOpen && !isOpen) startGuard();
      wasOpen = isOpen;
    }).observe(popup, { attributes: true, attributeFilter: ['open'] });
  };

  document.querySelectorAll('dialog.wpopup_main').forEach(watchPopup);

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('dialog.wpopup_main')) watchPopup(n);
        else n.querySelectorAll?.('dialog.wpopup_main').forEach(watchPopup);
      }
      for (const n of m.removedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('dialog.wpopup_main') || n.querySelector?.('dialog.wpopup_main')) {
          startGuard();
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();